var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnMenuGalleryEnding = function SvgIcnMenuGalleryEnding(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.468 19.5996H17.5346C11.8346 19.5996 7.16797 24.2662 7.16797 29.9662V67.833C7.16797 72.6663 10.6346 74.7329 14.868 72.3662L27.9679 65.0662C29.3679 64.2996 31.6346 64.2996 33.0013 65.0662L46.1013 72.3662C50.3346 74.7329 53.8013 72.6663 53.8013 67.833V29.9662C53.8346 24.2662 49.168 19.5996 43.468 19.5996Z",
    stroke: "currentcolor",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8346 17.0365V54.9033C73.8346 59.7366 70.368 61.7699 66.1346 59.4365L53.8346 52.5699V29.9699C53.8346 24.2699 49.168 19.6033 43.468 19.6033H27.168V17.0365C27.168 11.3365 31.8346 6.66992 37.5346 6.66992H63.468C69.168 6.66992 73.8346 11.3365 73.8346 17.0365Z",
    stroke: "currentcolor",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnMenuGalleryEnding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_menu_gallery_ending.ec2a7ed6.svg";
export { ForwardRef as ReactComponent };